import { repository, baseURL, cancelToken } from '@/api/base'

let cancel = null

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/commonWork/findAll')
    return data
  },

  async findAllForCurrentUser(page, body) {
    cancel && cancel()

    const { data } = await repository.post(baseURL + '/commonWork/findAllForCurrentUser/' + page, body, {
      cancelToken: new cancelToken(c => (cancel = c))
    })
    return data
  },

  async findAllByFilters(page, body) {
    cancel && cancel()

    const { data } = await repository.post(baseURL + '/commonWork/findAllByFilters/' + page, body, {
      cancelToken: new cancelToken(c => (cancel = c))
    })
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/commonWork', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/commonWork', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/commonWork/' + id)
  },

  async accept(id) {
    return await repository.put(baseURL + '/commonWork/accept/' + id)
  },

  async decline(id, body) {
    return await repository.patch(baseURL + '/commonWork/decline/' + id, body)
  },

  async sendToReview(id) {
    return await repository.put(baseURL + '/commonWork/sendToReview/' + id)
  },

  async sendToRevision(id, body) {
    return await repository.patch(baseURL + '/commonWork/sendToRevision/' + id, body)
  },

  async returnFromReview(id) {
    return await repository.put(baseURL + '/commonWork/returnFromReview/' + id)
  }
}
